import {
  createPolicy as publicCreatePolicy,
  updatePolicy as publicUpdatePolicy,
  deletePolicy as publicDeletePolicy,
  queryPolicies as publicQueryPolicies,
  typedQueryPolicies as publicTypedQueryPolicies,
  reorderEventPolicies as publicReorderEventPolicies,
  getPolicy as publicGetPolicy,
} from './events-v2-policy-policies.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PoliciesQueryBuilder,
  PolicyQuery,
  typedQueryPolicies as universalTypedQueryPolicies,
} from './events-v2-policy-policies.universal.js';
import { onPolicyCreated as publicOnPolicyCreated } from './events-v2-policy-policies.public.js';
import { onPolicyDeleted as publicOnPolicyDeleted } from './events-v2-policy-policies.public.js';
import { onPolicyUpdated as publicOnPolicyUpdated } from './events-v2-policy-policies.public.js';

function customQueryPolicies(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPolicies(httpClient)(),
    typedQueryFunction: (query: PolicyQuery) =>
      publicTypedQueryPolicies(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PoliciesQueryBuilder;
  function overloadedQuery(
    query: PolicyQuery
  ): ReturnType<typeof universalTypedQueryPolicies>;
  function overloadedQuery(query?: PolicyQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createPolicy: MaybeContext<
  BuildRESTFunction<typeof publicCreatePolicy> & typeof publicCreatePolicy
> = /*#__PURE__*/ createRESTModule(publicCreatePolicy);
export const updatePolicy: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePolicy> & typeof publicUpdatePolicy
> = /*#__PURE__*/ createRESTModule(publicUpdatePolicy);
export const deletePolicy: MaybeContext<
  BuildRESTFunction<typeof publicDeletePolicy> & typeof publicDeletePolicy
> = /*#__PURE__*/ createRESTModule(publicDeletePolicy);
export const reorderEventPolicies: MaybeContext<
  BuildRESTFunction<typeof publicReorderEventPolicies> &
    typeof publicReorderEventPolicies
> = /*#__PURE__*/ createRESTModule(publicReorderEventPolicies);
export const getPolicy: MaybeContext<
  BuildRESTFunction<typeof publicGetPolicy> & typeof publicGetPolicy
> = /*#__PURE__*/ createRESTModule(publicGetPolicy);
export const queryPolicies: MaybeContext<
  BuildRESTFunction<typeof customQueryPolicies> & typeof customQueryPolicies
> = /*#__PURE__*/ createRESTModule(customQueryPolicies);
/**
 * Triggered when a policy is created.
 */
export const onPolicyCreated: BuildEventDefinition<
  typeof publicOnPolicyCreated
> &
  typeof publicOnPolicyCreated = createEventModule(publicOnPolicyCreated);
/**
 * Triggered when a policy is deleted.
 */
export const onPolicyDeleted: BuildEventDefinition<
  typeof publicOnPolicyDeleted
> &
  typeof publicOnPolicyDeleted = createEventModule(publicOnPolicyDeleted);
/**
 * Triggered when a policy is updated.
 */
export const onPolicyUpdated: BuildEventDefinition<
  typeof publicOnPolicyUpdated
> &
  typeof publicOnPolicyUpdated = createEventModule(publicOnPolicyUpdated);

export {
  SortOrder,
  LocationType,
  SubdivisionType,
  Status,
  EventStatus,
  WebhookIdentityType,
} from './events-v2-policy-policies.universal.js';
export {
  Policy,
  CreatePolicyRequest,
  CreatePolicyResponse,
  UpdatePolicyRequest,
  UpdatePolicyResponse,
  UpdatePolicySortIndexRequest,
  UpdatePolicySortIndexResponse,
  DeletePolicyRequest,
  DeletePolicyResponse,
  QueryPoliciesRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryPoliciesResponse,
  PagingMetadataV2,
  Cursors,
  ReorderEventPoliciesRequest,
  ReorderEventPoliciesRequestReferencePolicyOneOf,
  ReorderEventPoliciesResponse,
  GetPolicyRequest,
  GetPolicyResponse,
  EventCopied,
  Location,
  MapCoordinates,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ScheduleConfig,
  Recurrences,
  Occurrence,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PolicyCreatedEnvelope,
  PolicyDeletedEnvelope,
  PolicyUpdatedEnvelope,
  UpdatePolicy,
  PoliciesQueryResult,
  PoliciesQueryBuilder,
  PolicyQuerySpec,
  ReorderEventPoliciesOptions,
  ReorderEventPoliciesOptionsReferencePolicyOneOf,
} from './events-v2-policy-policies.universal.js';
export { utils } from './events-v2-policy-policies.universal.js';
export {
  SortOrderWithLiterals,
  LocationTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  StatusWithLiterals,
  EventStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreatePolicyApplicationErrors,
  ReorderEventPoliciesApplicationErrors,
  CommonQueryWithEntityContext,
  PolicyQuery,
} from './events-v2-policy-policies.universal.js';
